import React from "react";
import NavLink from "./NavLink";
import { useLang } from "../context/lang";
import { useSidebar } from "../context/sidebar";
import logoTop from "../assets/logoTop.svg";
import { ReactComponent as Person } from "../assets/person.svg";
import { ReactComponent as Chart } from "../assets/chart.svg";
import { useDashboard } from "../context/dashboard";
import { ChevronLeftIcon, ChevronRightIcon } from "@primer/octicons-react";

import { ReactComponent as Exit } from "../assets/exit.svg";
import ChangeLanguage from "./ChangeLanguage";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useCognitoGroup } from "../hooks/useCognitoGroup";

const MenuComponent = () => {
  const { t } = useLang();
  const { user } = useAuthenticator();
  const { isMeritoGroup } = useCognitoGroup();
  const { available } = useDashboard();
  const { collapsed, toggle } = useSidebar();
  const [mobileOpened, setMobileOpened] = React.useState(false);

  const toogleNavbar = () => setMobileOpened((prev) => !prev);

  const logout = () => {
    user.signOut();
    window.location.reload();
  };

  return (
    <>
      <div className="hide-mobile">
        <div
          className={`bg-dark size-menu position-fixed sidebar-menu ${
            collapsed ? "is-collapsed" : ""
          }`}
        >
          <div className="sidebar-header w-100 flex-center">
            <button
              type="button"
              className="sidebar-toggle"
              onClick={toggle}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              aria-pressed={collapsed}
            >
              {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </button>
          </div>
          {!isMeritoGroup && (
            <NavLink to="/students" icon={<Person />} text={t("students")} />
          )}
          {available === true && (
            <NavLink to="/dashboard" icon={<Chart />} text={t("dashboard")} />
          )}
          {/* <NavLink to="/majors" icon={<Briefcase />} text={t("Majors")} />
          <NavLink to="/settings" icon={<Gear />} text={t("settings")} /> */}
          <ChangeLanguage />
          <div className="sidebar-bottom">
            <NavLink
              onClick={() => logout()}
              icon={<Exit />}
              text={t("logout")}
              iconOnly
            />
            <div className="sidebar-footer w-100 flex-center">
              <img className="sidebar-logo" src={logoTop} alt="StudentSpeak" />
            </div>
          </div>
        </div>
        <div className="size-menu"></div>
      </div>
      <div className="d-none show-mobile">
        <div className="bg-dark">
          <div className="d-flex flex-center-between">
            <img className="m-16" src={logoTop} alt="StudentSpeak" />

            <button
              className="navbar-toggler toggler-example"
              type="button"
              onClick={toogleNavbar}
            >
              <span className="text-white">
                <svg
                  style={{ width: "24px", height: "24px" }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="white"
                    d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
                  />
                </svg>
              </span>
            </button>
          </div>
          {mobileOpened && (
            <div className="bg-light ">
              {!isMeritoGroup && (
                <NavLink
                  to="/students"
                  icon={<Person />}
                  text={t("students")}
                />
              )}
              {available === true && (
                <NavLink
                  to="/dashboard"
                  icon={<Chart />}
                  text={t("dashboard")}
                />
              )}
              {/* <NavLink to="/majors" icon={<Briefcase />} text={t("Majors")} />
              <NavLink to="/settings" icon={<Gear />} text={t("settings")} /> */}
              <NavLink
                onClick={() => logout()}
                icon={<Exit />}
                text={t("logout")}
              />
            </div>
          )}
          <hr className="m-0" />
        </div>
      </div>
    </>
  );
};

export default MenuComponent;
